document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.hero-slider');

  sliders.forEach(slider => {
    const slidesContainer = slider.querySelector('.hero-slides'); // The moving track
    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.slider-dot');
    const prevBtn = slider.querySelector('.slider-arrow.prev');
    const nextBtn = slider.querySelector('.slider-arrow.next');
    
    // Fallback to 5000ms if data attribute is missing
    const duration = parseInt(slider.getAttribute('data-autoplay-speed')) || 5000;
    
    let currentIndex = 0;
    let autoPlayInterval = null;

    if (slides.length <= 1) {
      if(prevBtn) prevBtn.style.display = 'none';
      if(nextBtn) nextBtn.style.display = 'none';
      slider.querySelector('.slider-pagination').style.display = 'none';
      return; 
    }

    const startProgress = (index) => {
      dots.forEach(dot => {
        dot.classList.remove('active');
        const progress = dot.querySelector('.dot-progress');
        progress.style.transition = 'none';
        progress.style.width = '0%';
      });

      void slider.offsetWidth;

      dots[index].classList.add('active');
      const activeProgress = dots[index].querySelector('.dot-progress');
      activeProgress.style.transition = `width ${duration}ms linear`;
      activeProgress.style.width = '100%';
    };

    const goToSlide = (index) => {
      // Handle infinite loop bounds
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      
      currentIndex = index;
      
      // Execute the slide animation by moving the container
      slidesContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      startProgress(currentIndex);
      resetTimer();
    };

    const nextSlide = () => goToSlide(currentIndex + 1);
    const prevSlide = () => goToSlide(currentIndex - 1);

    const resetTimer = () => {
      clearInterval(autoPlayInterval);
      autoPlayInterval = setInterval(nextSlide, duration);
    };

    if(prevBtn) prevBtn.addEventListener('click', prevSlide);
    if(nextBtn) nextBtn.addEventListener('click', nextSlide);
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
      });
    });

    startProgress(currentIndex);
    resetTimer();
  });
});